import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
var defaults = {
  prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
  nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
  classNames: {
    main: "carousel__nav",
    button: "carousel__button",
    next: "is-next",
    prev: "is-prev"
  }
};
export var Navigation = /*#__PURE__*/function () {
  function Navigation(carousel) {
    _classCallCheck(this, Navigation);

    this.$container = null;
    this.$prev = null;
    this.$next = null;
    this.carousel = carousel;
    this.onRefresh = this.onRefresh.bind(this);
  }
  /**
   * Shortcut to get option for this plugin
   * @param {String} name option name
   * @returns option value
   */


  _createClass(Navigation, [{
    key: "option",
    value: function option(name) {
      return this.carousel.option("Navigation.".concat(name));
    }
    /**
     * Creates and returns new button element with default class names and click event
     * @param {String} type
     */

  }, {
    key: "createButton",
    value: function createButton(type) {
      var _$btn$classList,
          _this = this;

      var $btn = document.createElement("button");
      $btn.setAttribute("title", this.carousel.localize("{{".concat(type.toUpperCase(), "}}")));
      var classNames = this.option("classNames.button") + " " + this.option("classNames.".concat(type));

      (_$btn$classList = $btn.classList).add.apply(_$btn$classList, _toConsumableArray(classNames.split(" ")));

      $btn.setAttribute("tabindex", "0");
      $btn.innerHTML = this.carousel.localize(this.option("".concat(type, "Tpl")));
      $btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.carousel["slide".concat(type === "next" ? "Next" : "Prev")]();
      });
      return $btn;
    }
    /**
     * Build necessary DOM elements
     */

  }, {
    key: "build",
    value: function build() {
      if (!this.$container) {
        this.$container = document.createElement("div");
        this.$container.classList.add(this.option("classNames.main"));
        this.carousel.$container.appendChild(this.$container);
      }

      if (!this.$next) {
        this.$next = this.createButton("next");
        this.$container.appendChild(this.$next);
      }

      if (!this.$prev) {
        this.$prev = this.createButton("prev");
        this.$container.appendChild(this.$prev);
      }
    }
    /**
     *  Process carousel `refresh` and `change` events to enable/disable buttons if needed
     */

  }, {
    key: "onRefresh",
    value: function onRefresh() {
      var pageCount = this.carousel.pages.length;

      if (pageCount <= 1 || pageCount > 1 && this.carousel.elemDimWidth < this.carousel.wrapDimWidth && !Number.isInteger(this.carousel.option("slidesPerPage"))) {
        this.cleanup();
        return;
      }

      this.build();
      this.$prev.removeAttribute("disabled");
      this.$next.removeAttribute("disabled");

      if (this.carousel.option("infiniteX", this.carousel.option("infinite"))) {
        return;
      }

      if (this.carousel.page <= 0) {
        this.$prev.setAttribute("disabled", "");
      }

      if (this.carousel.page >= pageCount - 1) {
        this.$next.setAttribute("disabled", "");
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.$prev) {
        this.$prev.remove();
      }

      this.$prev = null;

      if (this.$next) {
        this.$next.remove();
      }

      this.$next = null;

      if (this.$container) {
        this.$container.remove();
      }

      this.$container = null;
    }
  }, {
    key: "attach",
    value: function attach() {
      this.carousel.on("refresh change", this.onRefresh);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.carousel.off("refresh change", this.onRefresh);
      this.cleanup();
    }
  }]);

  return Navigation;
}(); // Expose defaults

Navigation.defaults = defaults;